import { render, staticRenderFns } from "./EmailingRecipientsChip.vue?vue&type=template&id=71e547c0"
import script from "./EmailingRecipientsChip.vue?vue&type=script&lang=js"
export * from "./EmailingRecipientsChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports